export default "/img/MX.89f2ef472960aeed4315d79fd2115a60.png";